import { AnalyticsInfoIcon, Heading } from '@weave/design-system';
import { InfoCard } from '../InfoCard/InfoCard';
import { childStyles } from './styles';
import { ChurnRiskLevel } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/shared/enums.pb';
import { getChurnRiskLevelLabel } from '../../utils/helper';
import { css } from '@emotion/core';
import { theme } from '@weave/theme';

type InsurancePayerMixChurnRiskProp = {
  churnRisk?: ChurnRiskLevel;
};

export const InsurancePayerMixChurnRisk = ({
  churnRisk,
}: InsurancePayerMixChurnRiskProp) => {
  console.log(churnRisk, 'churnRisk');
  return (
    <InfoCard
      title="Churn Risk"
      {...(churnRisk && { style: insurancePayerMixChurnRiskStyles(churnRisk) })}
    >
      <div css={[childStyles]}>
        <AnalyticsInfoIcon size={30} />
        <Heading level={2} css={{ margin: 0 }}>
          {churnRisk ? getChurnRiskLevelLabel(churnRisk) : '-'}
        </Heading>
      </div>
    </InfoCard>
  );
};

const insurancePayerMixChurnRiskStyles = (churnRisk?: ChurnRiskLevel) =>
  css({
    color:
      churnRisk === ChurnRiskLevel.CHURN_RISK_LEVEL_HIGH
        ? theme.colors.critical50
        : churnRisk === ChurnRiskLevel.CHURN_RISK_LEVEL_MEDIUM
        ? theme.colors.warning50
        : theme.colors.success50,

    background:
      churnRisk === ChurnRiskLevel.CHURN_RISK_LEVEL_HIGH
        ? theme.colors.critical10
        : churnRisk === ChurnRiskLevel.CHURN_RISK_LEVEL_MEDIUM
        ? theme.colors.warning5
        : theme.colors.success10,
  });
